module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/tsJsG9/tc-custom/9781459234796.jpg?1728954633242",
      "alt": "This image is the cover for the book Playing the Greek's Game, What His Money Can't Buy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Playing the Greek's Game, What His Money Can't Buy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Few dare to defy global hotel magnate Zak Constantinideshe's the boss and everyone knows it! So when his London interior designer turns out to have dug her gold-digging claws into his brother, Zak's solution is to transfer herto New York!"), _c('br'), _c('br'), _vm._v("Emma may have more skeletons in her closet than most, but Zak's brother "), _c('i', [_vm._v("isn't")]), _vm._v(" one of them. The temptation to take her impossibly arrogant boss down a peg or three is too much to resist. So while with him in New York, she'll play the role he's given her and "), _c('i', [_vm._v("be every bit as bad")]), _vm._v(" as he thinks she is."), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sharon Kendrick\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sharon Kendrick started story-telling at the age of eleven and has never stopped. She likes to write fast-paced, feel-good romances with heroes who are so sexy they’ll make your toes curl! She lives in the beautiful city of Winchester – where she can see the cathedral from her window (when standing on tip-toe!). She has two children, Celia and Patrick and her passions include music, books, cooking and eating – and drifting into daydreams while working out new plots.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0